import React, { useEffect, useRef } from 'react';

const GoogleTranslate = () => {
  const initialized = useRef(false);

  useEffect(() => {
    // Empêcher les initialisations multiples
    if (initialized.current) return;

    const initGoogleTranslate = () => {
      try {
        const element = document.getElementById('google_translate_element');
        if (!element) return;

        // Vérifier si déjà initialisé
        if (element.querySelector('.goog-te-combo')) return;

        if (window.google && window.google.translate && window.google.translate.TranslateElement) {
          new window.google.translate.TranslateElement(
            {
              pageLanguage: 'fr',
              includedLanguages: 'en,es,de,it,nl,pt',
              layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
              autoDisplay: false,
            },
            'google_translate_element'
          );
          initialized.current = true;
        }
      } catch (error) {
        console.warn('Google Translate init error (non-blocking):', error.message);
      }
    };

    // Définir la fonction globale une seule fois
    if (!window.googleTranslateElementInit) {
      window.googleTranslateElementInit = initGoogleTranslate;
    }

    // Vérifier si le script existe déjà
    const existingScript = document.querySelector('script[src*="translate.google.com/translate_a/element.js"]');
    
    if (!existingScript) {
      const addScript = document.createElement('script');
      addScript.setAttribute(
        'src',
        '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit'
      );
      addScript.onerror = () => {
        console.warn('Google Translate script failed to load (non-blocking)');
      };
      document.body.appendChild(addScript);
    } else if (window.google && window.google.translate) {
      // Script déjà chargé, initialiser directement
      initGoogleTranslate();
    }
  }, []);

  return (
    <div id="google_translate_element" className="inline-block"></div>
  );
};

export default GoogleTranslate;
